const Banner = ({brand}) => {
  return (
    <>
      Banner
    </>
  )
};

export default Banner;